import { useQuery } from "@tanstack/react-query";

import {
  type DiarioFilters,
  diarioService,
} from "~/services/contabilidad/diarioService";

export const DIARIO_SUMMARY_QUERY_KEY = ["diario-summary"];

export function usePublishedMoveLines(filters: DiarioFilters) {
  return useQuery({
    queryKey: [...DIARIO_SUMMARY_QUERY_KEY, filters],
    queryFn: () => diarioService.getPublishedMoveLines(filters),
    enabled: !!filters.dateFrom && !!filters.dateTo,
  });
}
